import React, { memo } from 'react';
import MainVisualBanner from '@wconcept/wconcept-ui-renewal/src/components/molecules/_banner/MainVisualBanner';

interface MainVisualModuleProps {
  videoSrc?: string;
  videoPoster?: string;
  token?: string;
  imgSrc?: string;
  vid?: string;
  sizeType?: 'default' | 'small';
  title: string;
  subTitle: string;
  order: number;
  promotionId: string;
  promotionName: string;
}

export function MainVisualModule({
  vid,
  videoSrc,
  videoPoster,
  token,
  imgSrc,
  sizeType,
  title,
  subTitle,
  order,
  promotionId,
  promotionName,
}: MainVisualModuleProps) {
  return (
    <MainVisualBanner
      vid={vid}
      videoSrc={videoSrc ?? undefined}
      videoPoster={videoPoster}
      title={title}
      subTitle={subTitle}
      imgSrc={imgSrc}
      token={token && !videoSrc ? { playAuthToken: token } : undefined}
      priority
      definitionType={token && !videoSrc ? '1080p' : undefined}
      sizeType={sizeType}
    />
  );
}

export default memo(MainVisualModule);
